<div class="grid gap-4 md:grid-cols-2 xl:grid-cols-3">
  @for (item of items(); track item.id) {
    <div class="relative rounded-lg border border-gray-200 bg-white pr-6">
      @if (!isReadonly()) {
        <div class="absolute -top-3 -right-3">
          <p-button
            (onClick)="handleRemoveClick(item)"
            pTooltip="Usuń"
            severity="danger"
            size="small"
            styleClass="size-6"
            tooltipPosition="bottom"
            type="button">
            <app-icon [icon]="Icon.X" />
          </p-button>
        </div>
      }

      <div class="flex items-center gap-4">
        <div class="size-18 shrink-0">
          @if (isNotNil(item.featureFileUrl)) {
            <app-image-thumbnail size="full">
              <img
                [ngSrc]="item.featureFileUrl"
                [fill]="true"
                [alt]="item.featureFileAlt"
                class="object-contain" />
            </app-image-thumbnail>
          } @else {
            <app-image-thumbnail-unsupported size="lg" />
          }
        </div>

        <div class="min-w-0 flex-1 py-1">
          <div class="text-sm font-semibold break-words text-gray-900">
            {{ item.name }}
          </div>

          <div class="mt-1 text-sm break-words text-gray-500">
            @if (isNotNil(item.cosmeticBrandName)) {
              {{ item.cosmeticBrandName }}
            } @else {
              <app-no-data />
            }
          </div>
        </div>
      </div>
    </div>
  }
</div>
